import * as types from "./types";

export const setSearchSettings = searchSettings => {
  return { type: types.SET_SEARCH_SETTINGS, payload: searchSettings };
};

export const clearSearchFilter = () => {
  return { type: types.CLEAR_SEARCH_FILTER };
};

export const clearCurrrentLocation = () => {
  return { type: types.CLEAR_CURRENT_LOCATION };
};
